// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1X94M","location":"Header_location__DyfVJ"};